import React from 'react';
import classNames from 'classnames';
import { SmallCard } from './SmallCard';
import { SmallCardContent, SmallCardMiddle } from './SmallCardMiddle';
import { IColumnHeader, MDFListHeader } from '../MDFListHeader';
import { FormatHelper } from '@adp-wfn/mdf-core';

export interface IMDFListCardProps {
  cardClass?: string;
  className?: string;
  columns: IColumnHeader[];
  defaultSortable?: boolean;
  items: object[];
  noDataMessage?: string;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  onSort?: (columnId) => any;
}

export class MDFListCard extends React.Component<React.PropsWithChildren<IMDFListCardProps>, any> {
  renderCard = (item: any, idx: number) => {
    const cardClass = `small-card--list-card ${this.props.cardClass || ''}`;

    return (
      <SmallCard cardStyle={'flat'} className={cardClass} key={idx}>
        <SmallCardMiddle>
          <SmallCardContent>
            {this.props.columns.map((column, index) => <div key={column.id ?? index} className={classNames('small-card--list-card-column', column.className)}>{item[column.id]}</div>)}
          </SmallCardContent>
        </SmallCardMiddle>
      </SmallCard>
    );
  };

  renderNoDataMessage = () => (
    <div className={'mdf-grid-noDataMessage'}>
      {this.props.noDataMessage ? this.props.noDataMessage : ` ${FormatHelper.formatMessage('@@NoRowsFound')}`}
    </div>
  );

  render() {
    const { className, children, cardClass, items, columns, ...headerProps } = this.props;

    return (
      <div className={classNames(className)}>
        <MDFListHeader columnHeaders={columns} {...headerProps} />
        {items?.length > 0 ? items.map(this.renderCard) : this.renderNoDataMessage()}
      </div>
    );
  }
}
